import * as api from '@owl-nest/api-client/latest'

export async function deleteImage(imageId: string): Promise<api.ApiResponse<any>> {
  const response = await api.api.delete.image({ urlParams: { imageId } })

  return response.next((success) => {
    return success.body
  })
}
